import gql from 'graphql-tag'

export default gql`{
    projectHoursWorkedLast30Days{
      timesheet_date
      project_id
      hours_worked
    }
  }`